import { create } from "zustand";
import type { User } from "@/types";

interface UserState {
  user: User | null;
  isLoading: boolean;
  credits: number;
  hasPurchased: boolean;
  accTier: number;
  setUser: (user: User | null) => void;
  setLoading: (loading: boolean) => void;
  updateCredits: (credits: number) => void;
}

export const useUserStore = create<UserState>((set) => ({
  user: null,
  isLoading: true,
  credits: 0,
  hasPurchased: false,
  accTier: 0,
  setUser: (user) =>
    set({
      user,
      credits: user?.credit_balance ?? 0,
      hasPurchased: user?.highest_package != null,
      accTier: user?.acc_tier ?? 0,
    }),
  setLoading: (isLoading) => set({ isLoading }),
  updateCredits: (credits) =>
    set((state) => ({
      credits,
      user: state.user ? { ...state.user, credit_balance: credits } : null,
    })),
}));
